(() => {
  'use strict';
  document.documentElement.classList.remove('no-js');
  const init = (root = document) => {
    root.querySelectorAll('[data-scroll]').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      button.addEventListener('click', () => {
        const track = document.getElementById(button.getAttribute('aria-controls'));
        const card = track?.querySelector('.product-card');
        if (track && card) track.scrollBy({left: Number(button.dataset.scroll) * (card.offsetWidth + 24), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      });
    });
    root.querySelectorAll('[data-product-section]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const form = section.querySelector('.product-form');
      const variants = JSON.parse(section.querySelector('[data-product-variants]').textContent);
      const prices = JSON.parse(section.querySelector('[data-variant-prices]').textContent);
      const options = [...form.querySelectorAll('[data-option-index]')];
      const fields = [...form.querySelectorAll('[data-custom-field]')];
      const id = form.querySelector('[data-variant-id]');
      const button = form.querySelector('[data-add-to-cart]');
      const delivery = section.querySelector('[data-delivery-estimate]');
      const gallery = section.querySelector('.main-product-image');
      const quantity = form.querySelector('[name="quantity"]');
      const setImage = (src, alt) => {
        if (!gallery || !src) return;
        gallery.removeAttribute('srcset');
        gallery.src = src;
        gallery.alt = alt || gallery.alt;
      };
      const syncField = (field, chosen) => {
        const linked = field.hasAttribute('data-linked-option-index');
        const active = !linked || chosen[Number(field.dataset.linkedOptionIndex)] === field.dataset.linkedPersonalisedValue;
        field.hidden = !active;
        const select = field.querySelector('[data-custom-select]');
        field.querySelectorAll('input, select').forEach(input => {
          input.disabled = !active;
          input.required = active && linked && input.type !== 'hidden';
        });
        if (select) {
          const custom = active && select.value === '__custom';
          const text = field.querySelector('[data-custom-text]');
          field.querySelector('[data-custom-text-wrap]').hidden = !custom;
          text.disabled = !custom;
          text.required = custom && linked;
          const mirror = field.querySelector('[data-custom-value]');
          mirror.value = active ? (custom ? text.value : select.value) : '';
        }
        return linked && active;
      };
      const sync = (updateUrl = false) => {
        const chosen = options.map(option => option.value);
        const variant = options.length ? variants.find(item => chosen.every((value, index) => item.options[index] === value)) : variants.find(item => String(item.id) === id.value);
        const personalised = fields.map(field => syncField(field, chosen)).some(Boolean);
        delivery.textContent = personalised ? (delivery.dataset.bespoke || delivery.dataset.standard) : delivery.dataset.standard;
        button.disabled = !variant?.available;
        button.textContent = !variant ? 'Nicht verfügbar' : variant.available ? 'In den Warenkorb' : 'Ausverkauft';
        section.querySelector('[data-variant-status]').textContent = !variant ? 'Diese Kombination ist nicht verfügbar. Bitte wähle eine andere Variante.' : '';
        id.disabled = !variant;
        id.value = variant?.id || '';
        if (!variant) return;
        section.querySelector('[data-product-price]').textContent = prices[variant.id].price;
        const compare = section.querySelector('[data-compare-price]');
        compare.hidden = !(variant.compare_at_price > variant.price);
        compare.textContent = prices[variant.id].compare;
        if (variant.quantity_rule) {
          quantity.min = variant.quantity_rule.min;
          quantity.step = variant.quantity_rule.increment;
          if (variant.quantity_rule.max) quantity.max = variant.quantity_rule.max;
          else quantity.removeAttribute('max');
          if (Number(quantity.value) < variant.quantity_rule.min) quantity.value = variant.quantity_rule.min;
        }
        if (updateUrl) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState(history.state, '', url);
          if (variant.featured_image) setImage(variant.featured_image.src, variant.featured_image.alt);
        }
      };
      options.forEach(option => option.addEventListener('change', () => sync(true)));
      fields.forEach(field => field.addEventListener('input', () => syncField(field, options.map(option => option.value))));
      fields.forEach(field => field.addEventListener('change', () => syncField(field, options.map(option => option.value))));
      section.querySelectorAll('[data-gallery-src]').forEach(thumb => thumb.addEventListener('click', () => {
        setImage(thumb.dataset.gallerySrc, thumb.dataset.galleryAlt);
        section.querySelectorAll('[data-gallery-src]').forEach(other => other.setAttribute('aria-pressed', String(other === thumb)));
      }));
      form.addEventListener('submit', event => {
        sync();
        if (button.disabled || !form.reportValidity()) event.preventDefault();
      });
      sync();
    });
    root.querySelectorAll('[data-tracking-form]').forEach(form => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      form.addEventListener('submit', event => {
        event.preventDefault();
        if (!form.reportValidity()) return;
        const number = form.querySelector('input').value.trim();
        if (number) window.open('https://t.17track.net/de#nums=' + encodeURIComponent(number), '_blank', 'noopener,noreferrer');
      });
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const menu = document.querySelector('.mobile-menu[open]');
    if (menu) { menu.open = false; menu.querySelector('summary').focus(); }
  });
})();
